import { DialogTitle } from "@headlessui/react";
import { CheckIcon } from "@heroicons/react/24/outline";
import Loader from "components/Loader";
import Button from "components/buttons/Button";
import TextAreaFormField from "components/form/TextAreaFormField";
import Modal from "components/modal/Modal";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useAcceptMultipleOffersForm } from "../../hooks/useAcceptOfferForm";
import ErrorModal from "./ErrorModal";
import { AcceptOrRejectMultipleOffersResponseDto } from "../../offer.typing";

interface Props {
  show: boolean;
  offerIds: string[];
  onClose: () => void;
}

const AcceptOffersModal = ({ show, offerIds = [], onClose }: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "offer.modal.accept" });
  const [error, setError] = useState<AcceptOrRejectMultipleOffersResponseDto | null>(null);

  const handleError = (err: AcceptOrRejectMultipleOffersResponseDto) => {
    setError(err);
  };

  const handleErrorClose = () => {
    setError(null);
    handleClose();
  };

  const { accept, reset, register, isPending } = useAcceptMultipleOffersForm(offerIds, onClose, handleError);

  const handleClose = () => {
    reset();
    onClose();
  };

  return (
    <>
      <Modal isShown={show} onClose={handleClose}>
        <div>
          {/*Icon*/}
          <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-green-100">
            <CheckIcon className="size-6 text-green-600" aria-hidden="true" />
          </div>
          {/*Header*/}
          <div className="mt-3 text-center sm:mt-5">
            <DialogTitle as="h3" className="text-color-primary text-lg font-medium leading-6 sm:text-3xl">
              <div>{t("title", { count: offerIds.length })}</div>
            </DialogTitle>
            <div className="mt-6 flex flex-col text-center">
              <div className="text-base font-medium">{t("subTitle-multiple", { count: offerIds.length })}</div>
            </div>
          </div>

          {/*body*/}
          <div>
            <form className="mx-4 mt-6 flex flex-col space-y-5" onSubmit={accept}>
              {isPending ? (
                <Loader isShown={true} />
              ) : (
                <TextAreaFormField
                  id="comment"
                  label={t("form.comment")}
                  className="max-h-52"
                  {...register("comment")}
                />
              )}
              <div className="mt-5 grid grid-cols-2 gap-3 sm:mt-6 sm:grid-flow-row-dense">
                <Button type="reset" disabled={isPending} color="ternary" label={t("cancel")} onClick={handleClose} />
                <Button type="submit" disabled={isPending} color="primary" label={t("confirm")} />
              </div>
            </form>
          </div>
        </div>
      </Modal>
      {error && <ErrorModal show={true} error={error} onClose={handleErrorClose} type="accept" />}
    </>
  );
};
export default AcceptOffersModal;
